import { render } from "./Profil.vue?vue&type=template&id=734baf80"
import script from "./Profil.vue?vue&type=script&lang=ts"
export * from "./Profil.vue?vue&type=script&lang=ts"
script.render = render

export default script